import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCWolf extends NPC {
    constructor() {
        super(definitions.NPC_ID.WOLF);

        this.collisionRadius = 30;
        this.collisionOffsetX = 0;
        this.collisionOffsetY = -32;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_the_big_bad_wolf_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 1, new PIXI.Point(-2, -10));
        this.animateIdle(1);
    }
}